import { useSiteTheme } from "@/components/SiteThemeProvider";
import { type ThemeLayoutKey } from "@/lib/themeLayouts";

/**
 * Resolves which page layout the current visitor should see.
 *
 * SSR remains Classic. The root provider resolves layout and colors once,
 * reveals them together, and retains the selection across page navigation.
 */
export function useThemeLayout(): ThemeLayoutKey {
  return useSiteTheme().layout;
}
